<div class="ui-header-toggle" (click)="toggleMenu()">
  <i *ngIf="!open" class="fas fa-bars"></i>
  <i *ngIf="open" class="fas fa-times"></i>
</div>

<div class="ui-header-logo">
  <img [src]="system.logoFirst" alt="">
</div>
<div *ngIf="system.logoSecondary" class="ui-header-logo">
  <img [src]="system.logoSecondary" alt="">
</div>

<div class="ui-header-user">
  <div class="ui-header-user-icon">
    <i class="fas fa-user"></i>
  </div>

  <div class="ui-header-user-name">
    {{username}}
  </div>

  <div class="ui-header-user-menu" mat-button [matMenuTriggerFor]="menu">
    <i class="fas fa-angle-down"></i>
    <mat-menu #menu="matMenu" class="ui-panel-menu ui-panel-menu-inverse" xPosition="before">
      <button mat-menu-item [routerLink]="['/app/profile']" *ngIf="showOption">Editar perfil
        <mat-icon fontIcon="fa-edit" fontSet="fal"></mat-icon>
      </button>

      <button mat-menu-item [routerLink]="['/app/notifications']">Notificaciones
        <mat-icon fontIcon="fa-bell" fontSet="fal"></mat-icon>
      </button>

      <button mat-menu-item [routerLink]="['/app/messages']">Mensajes
        <mat-icon fontIcon="fa-envelope-open-text" fontSet="fal"></mat-icon>
      </button>

      <button mat-menu-item (click)="logout()">
        Cerrar sesión
        <mat-icon fontIcon="fa-sign-out" fontSet="fal"></mat-icon>
      </button>
    </mat-menu>
  </div>
</div>



